module.exports = __webpack_public_path__ + "img/1440.9131fae3.jpg";